import { accountSDK, AccountHomeView } from '@fanduel/fd-aw-sdk';
const awFlowsWebSDK = accountSDK();

const basicAuth = (username, password = '') => {
  return window.btoa(username + ':' + password);
};

const AWFlows = {
  getSession: async hint => {
    return awFlowsWebSDK.getSession(hint);
  },
  clearSession: () => {
    return awFlowsWebSDK.clearSession();
  },
  setConfig: async config => {
    const webConfig = {
      appDomain: config.appDomain,
      clientId: basicAuth(config.clientAuthToken),
      environment: config.environment.type === 'devStack' ? config.environment.name : config.environment.type
    };
    return awFlowsWebSDK.setConfig(webConfig).then(() => true).catch(() => false);
  },
  setCallback: callback => {
    return awFlowsWebSDK.setCallback(callback);
  }
};
export default AWFlows;
export { AccountHomeView };
//# sourceMappingURL=AWFlows.js.map